import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AccessTab from 'admin/views/multi-access';

const SiteDesignAccess = ({
   access,
   handleAccsessChange,
   screenWidth,
   membersStatistics = {},
   isAutoSave,
   isHomepage,
}) => {
   const [data, setData] = useState(access)
   const onAccsessChange = (newData, callBack) => {
      let updateValue = { ...data }
      if('access_members_different' in newData) {
         updateValue = {
            multiple_access_members: data.multiple_access_members.map(elm => {
               let i = { ...elm }
               let key = i.id
               if(!key) key = i.type
               if([key]  in newData.access_members_different){
                  i = { ...i, access: { ...newData.access_members_different[key] } }
               }
               return i
            }),
         }
      }
      if('access_others_different' in newData) {
         updateValue = {
            multiple_access_others: data.multiple_access_others.map(elm => {
               let i = { ...elm }
               let key = i.id
               if(!key) key = i.type
               if([key] in newData.access_others_different){
                  i = { ...i, access: { ...newData.access_others_different[key] } }
               }
               return i
            }),
         }
      }

      const allState = {
         ...data,
         ...updateValue,
         ...newData,
      }
      if(isAutoSave) {
         let keys = Object.keys(newData);
         if(keys.length === 1) {
            setData({
               ...data,
               ...updateValue,
               ...newData,
            })
         }
         handleAccsessChange(newData, () => {
            if(callBack){
               callBack()
            }
            setData(allState)
         })
      } else {
         handleAccsessChange(newData);
         setData({
            ...data,
            ...updateValue,
            ...newData,
         })
         if(callBack){
            callBack()
         }
      }
   }
   return (
      <AccessTab
         membersMode={ data.access_for_members_mode }
         othersMode={ data.access_for_others_mode }
         membersAll={ data.access_members_all }
         othersAll={ data.access_others_all }
         differentMembers={ data.multiple_access_members }
         differentOthers={ data.multiple_access_others }
         handleAccsessChange={ onAccsessChange }
         contentType='custom_page'
         membersStatistics={ membersStatistics }
         isMobile={ screenWidth < 1025 }
         showNewStyles
         isHomepage={ isHomepage }
      />
   )
};


SiteDesignAccess.propTypes = {
   handleAccsessChange: PropTypes.func.isRequired,
   access: PropTypes.object,
   isHomepage: PropTypes.bool,
   screenWidth: PropTypes.number,
   membersStatistics: PropTypes.object,
   isAutoSave: PropTypes.bool,
};

export default SiteDesignAccess;
